module.exports = __webpack_public_path__ + "img/p4.8822a9c9.png";